<!--
    Program: BulletinView.vue
    Author: SDL
    Description: 
    Created: 2020.03.13
-->
<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal_size lg_size">
                <a href="javascript:" class="ui_close" @click="btnClose">
                    <span class="sr_only">popup close</span>
                </a>
                <dl v-if="isLoading" class="modal_content" style="height: 300px; line-height: 150px; text-align: center;">
                    please wait...
                </dl>
                <dl v-else class="modal_content">
                    <dt class="ellipsis maintit">
                        <i>{{ $t('FIELD.KNOWLEDGE.SEE.DETAILS') }}</i>
                    </dt>
                    <dd>
                        <div class="view_cont">
                            <!-- <div class="view_info">
                                <div
                                    class="view_category"
                                    v-if="typeof detail.PRD_CATEGORY_NM1 !== 'undefined'"
                                >
                                    {{ detail.PRD_CATEGORY_NM1 }}
                                    <em
                                        v-if="typeof detail.PRD_CATEGORY_NM2 !== 'undefined'"
                                    >&gt;</em>
                                    {{ detail.PRD_CATEGORY_NM2 }}
                                    <em
                                        v-if="typeof detail.PRD_CATEGORY_NM3 !== 'undefined'"
                                    >&gt;</em>
                                    {{ detail.PRD_CATEGORY_NM3 }}
                                </div>
                            </div> -->
                            <dl class="view_subject">
                                <dt class="subject">
                                    {{ view.title }}
                                </dt>
                                <dd class="desc">
                                    <span class="desc_Regist">
                                        <em>{{ $t('FIELD.GLOBAL.REGISTERED.BY') }}</em>
                                        {{ view.reg_user_id }} ({{ view.reg_dt }})
                                    </span>
                                </dd>
                            </dl>

                            <!-- tab -->
                            <div class="view_desc">
                                <div class="sub_tit">Basic Info.</div>
                                <!-- detail_f -->
                                <table class="create_table">
                                    <colgroup>
                                        <col width="15%" />
                                        <col width="*" />
                                        <col width="15%" />
                                        <col width="*" />
                                    </colgroup>
                                    <tbody>
                                        <tr>
                                            <th>Date</th>
                                            <td>{{view.reg_dt}}</td>
                                            <th>Register</th>
                                            <td>{{view.reg_user_id}}</td>
                                        </tr>
                                        <tr>
                                            <th>Type</th>
                                            <td>{{view.type1}} / {{view.type2}}</td>
                                            <th></th>
                                            <th></th>
                                        </tr>
                                        <tr>
                                            <th>Urgency</th>
                                            <td>
                                                <label
                                                    :class="{ txt_red: view.urgency_yn === 'Y' }"
                                                    v-if="view.urgency_yn === 'Y'"
                                                >Urgent</label>
                                                <label v-else>Normal</label>
                                            </td>
                                            <th>Need Translation</th>
                                            <td>
                                                <label
                                                    :class="{ txt_red: view.need_reprocess === 'Y' }"
                                                >{{view.need_reprocess}}</label>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Required Translations</th>
                                            <td colspan="3" class="txt_red">{{view.tran}}</td>
                                        </tr>
                                        <tr>
                                            <th>Title</th>
                                            <td colspan="3">{{view.title}}</td>
                                        </tr>
                                        <tr>
                                            <th>Tag Info</th>
                                            <td colspan="3">{{view.tag_info}}</td>
                                            <!-- <th>Sort</th>
                                            <td>Move to the top</td>-->
                                        </tr>
                                        <tr>
                                            <th>User Level</th>
                                            <td colspan="3">
                                                <ul class="ul_list max_scrollbar">
                                                    <li
                                                        class="userlevel_txt"
                                                        v-for="level in userLevelList"
                                                        :key="level.CODE_ID"
                                                    >{{level.CODE_ID}} ({{level.CODE_NAME}})</li>
                                                </ul>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Country / Region</th>
                                            <td colspan="3">
                                                <ul class="ul_list max_scrollbar">
                                                    <li
                                                        class="userlevel_txt"
                                                        v-for="country in countryList"
                                                        :key="country"
                                                    >{{country}}</li>
                                                </ul>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Contents</th>
                                            <td colspan="3">
                                                <span v-html="view.content || getBlankTemplate"></span>
                                                <!-- <cross-editor-viewer
                                                    :editorId="'editorId-'+view.seq"
                                                    :editorData="view.content || getBlankTemplate"
                                                /> -->
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Attachment</th>
                                            <td colspan="3" class="no_padding">
                                                <innorix-download
                                                    :id="view.seq"
                                                    :name="view.seq"
                                                    :uploadId="view.seq"
                                                    serviceType="common"
                                                    :attachList="fileList"
                                                    v-if="fileList.length > 0"
                                                />
                                                <span v-else style="font-style: italic;">
                                                    No Attachment
                                                </span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <!-- //detail -->
                            </div>
                            <div class="btn_wrap topLine">
                                <div class="btn_right pc_only">
                                    <!--
                                    <a href="javascript:" v-if="btnAuth()" class="btn_white" title="" @click="btnExpire">{{ $t('BUTTON.GLOBAL.EXPIRE') }}</a>
                                    <a href="javascript:" v-if="btnAuth()" class="btn_white" title="" @click="btnModify">{{ $t('BUTTON.GLOBAL.MODIFY') }}</a>
                                    -->
                                    <a
                                        href="javascript:"
                                        class="btn_white"
                                        title
                                        @click="btnClose"
                                    >{{ $t('BUTTON.GLOBAL.CLOSE') }}</a>
                                </div>
                            </div>
                        </div>
                    </dd>
                </dl>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import axios from 'axios';
import qs from 'query-string';

import store from '@/vuex/store';
import constants from '@/constants';
import SDLLocale from '@/mixin/SDLLocale';
import { SDLUtil, MenuUtil } from '@/utils';
import { EventBus } from '@/utils/EventBus';

import CrossEditorViewer from '~c/CrossEditorViewer';
import InnorixDownload from '~c/InnorixDownload';

import BlankPageTempPage from '/static/sample/CREATE_Template_04.html';

export default {
    name: 'hhp-bulletin-view',
    components: {
        'cross-editor-viewer': CrossEditorViewer,
        'innorix-download': InnorixDownload,
    },
    props: {
        seq: {
            type: String,
            required: true,
        },
        rtnFunc: { type: Function },
    },
    computed: {
        getBlankTemplate() {
            return BlankPageTempPage;
        },
    },
    data() {
        return {
            isLoading: true,

            roleCd: '',
            view: {},
            countryList: [],
            userLevelList: [],
            fileList: [],
            encToken: '',

            delAttachFiles: [],
            isRemove: false,
        };
    },
    created() {
        console.log('Component:  created. ');
        this.init();
    },
    mounted() {
        console.log('Component:  mounted.');
    },
    methods: {
        async init() {
            const data = await this.fetchData();
            if (data === false) return;

            this.setData(data);
            // this.setUserList(data.userLevelList, );
        },
        fetchData() {
            const params = {
                seq: this.seq,
            };

            const path = '/basis/anysvcmobile/svcBulletin/sbView.skp';
            return SDLUtil.getRequest(path, params)
                .catch(err => {
                    console.log('ERRR', err);

                    if (err.data.error.code === 'HHP_LOGIN_REQUIRED') {
                        this.$emit('close');
                        SDLUtil.alert({
                            title: 'Login Required!',
                            msg: 'Please login to HHP first.',
                            onOkEvt: () => {
                            },
                        });
                        return false;
                    } else if (err.data.error.code === 'HHP_CERT_REQUIRED') {
                        this.$emit('close');
                        SDLUtil.alert({
                            title: 'HHP Access Required!',
                            msg: 'Please obtain access to HHP first.',
                            onOkEvt: () => {
                                this.$router.push({name: 'hhpRequestCert'});
                            },
                        });
                        return false;

                    } else if (err.data.error.code === 'HHP_MONTH_LOCK') {
                        this.$emit('close');
                        SDLUtil.alert({
                            title: 'HHP Access Required!',
                            msg: 'Your account is locked!<br>Please unlock the account using other request.',
                            onOkEvt: () => {
                                this.$router.push({name: 'hhpOtherRequest'});
                            },
                        });
                        return false;

                    } else if (err.data.error.code === 'HHP_LOGIN_LOCK') {
                        this.$emit('close');
                        SDLUtil.alert({
                            title: 'HHP Access Required!',
                            msg: 'Your account is locked!<br>Please unlock the account using other request.',
                            onOkEvt: () => {
                                this.$router.push({name: 'hhpOtherRequest'});
                            },
                        });
                        return false;

                    } else {
                        this.$emit('close');
                        SDLUtil.alert({
                            title: 'HHP Access Required!',
                            msg: 'You do not have sufficient permission',
                            onOkEvt: () => {
                            },
                        });
                        return false;

                    }
                });
        },

        setData(data) {
            this.roleCd = data.roleCd;

            this.view = data.view;
            this.view.tran = data.view.tran
                .split(',')
                .filter(item => item)
                .map(item => item.replace(/ /g, ''))
                .join(', ');
            // this.view.tran = data.view.tran.replace(',', ''); // replace the first comman.
            this.view.content = SDLUtil.stripHtml(data.view.content);

            this.encToken = data.encToken;
            this.fileList = data.fileList;
            console.log('fileList', this.fileList);

            // console.log('this.view.tran', this.view.tran);
            this.countryList = data.country.map(item => item.COUNTRY_NM).sort();
            // console.log('countryList', this.countryList);
            this.userLevelList = data.userLevelList.map(item => {
                const matched = data.userLevelLabelList.find(i => i.CODE_ID === item.USER_LEVEL);
                return {
                    CODE_ID: item.USER_LEVEL,
                    CODE_NAME: matched ? matched.CODE_NAME : '',
                };
            });
            console.log('userLevelList', this.userLevelList);

            this.isLoading = false;
        },

        // setUserLevelList(list) {},

        // setCountryList(list) {},

        btnClose() {
            if (typeof this.rtnFunc === 'function') {
                this.rtnFunc();
            }

            this.$emit('close');
        },

        setAttachFiles(val) {
            Vue.$log.info('▶ InnorixDownload.vue -> BulletinView.vue / files : ', val);
            this.fileList = val.fileList || [];
            this.delAttachFiles = val.delFileList || [];
            this.isRemove = val.isRemove || false;
        },
    },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/anysvcmobile/svcBulletin/BulletinViewPopup.vue